<div class="title-section">
  <h3 class="font-size-24 font-weight-bold mb-1">{{ title | translate }} </h3>
  @if (!!messageTooltip || !!titleTooltip) {
    <ng-contaier
      ><app-more-info-tooltip [message]="messageTooltip" [titleTooltip]="titleTooltip"></app-more-info-tooltip
    ></ng-contaier>
  }
</div>
